import * as CANNON from 'cannon-es';
import CannonDebugger from 'cannon-es-debugger';

export default class Physics {

    constructor(GAME) {
        this.GAME = GAME;

        this.init();
    }

    init() {
        this.GAME.physicsWorld = new CANNON.World({ gravity: new CANNON.Vec3(0, -9.82, 0) });

        const groundMaterial = Object.assign(new CANNON.Material('groundMaterial'), {
            friction: this.GAME.config.ground.friction
        });

        this.GAME.ballMaterial = Object.assign(new CANNON.Material('ballMaterial'), {
            friction: this.GAME.config.ball.friction
        });

        const ballGroundContactMaterial = new CANNON.ContactMaterial(groundMaterial, this.GAME.ballMaterial, {
            friction: Math.min(this.GAME.config.ground.friction, this.GAME.config.ball.friction),
            restitution: this.GAME.config.ball.restitution,
        });

        this.GAME.groundBody = new CANNON.Body({
            type: CANNON.Body.STATIC,
            shape: new CANNON.Box(new CANNON.Vec3(this.GAME.config.ground.width, this.GAME.config.ground.depth, this.GAME.config.ground.height)),
            material: groundMaterial,
        });

        this.GAME.shotClockPost = new CANNON.Body({
            type: CANNON.Body.STATIC,
            shape: new CANNON.Cylinder(this.GAME.config.shot_clock.post.diameter, this.GAME.config.shot_clock.post.diameter, this.GAME.config.shot_clock.post.height, 10),
            position: new CANNON.Vec3(this.GAME.config.shot_clock.post.position.x, this.GAME.config.shot_clock.post.position.y, this.GAME.config.shot_clock.post.position.z)
        });

        this.GAME.shotClockDisplay = new CANNON.Body({
            type: CANNON.Body.STATIC,
            shape: new CANNON.Box(new CANNON.Vec3(this.GAME.config.shot_clock.display.width / 2, this.GAME.config.shot_clock.display.height / 2, this.GAME.config.shot_clock.display.depth / 2)),
            position: new CANNON.Vec3(this.GAME.config.shot_clock.display.position.x, this.GAME.config.shot_clock.display.position.y, this.GAME.config.shot_clock.display.position.z)
        });

        this.GAME.postLeft = new CANNON.Body({
            type: CANNON.Body.STATIC,
            shape: new CANNON.Cylinder(this.GAME.config.postLeft.diameter, this.GAME.config.postLeft.diameter, this.GAME.config.postLeft.height, 10),
            position: new CANNON.Vec3(this.GAME.config.postLeft.position.x, this.GAME.config.postLeft.position.y, this.GAME.config.postLeft.position.z)
        });

        this.GAME.postRight = new CANNON.Body({
            type: CANNON.Body.STATIC,
            shape: new CANNON.Cylinder(this.GAME.config.postRight.diameter, this.GAME.config.postRight.diameter, this.GAME.config.postRight.height, 10),
            position: new CANNON.Vec3(this.GAME.config.postRight.position.x, this.GAME.config.postRight.position.y, this.GAME.config.postRight.position.z)
        });

        this.GAME.postMiddle = new CANNON.Body({
            type: CANNON.Body.STATIC,
            shape: new CANNON.Cylinder(this.GAME.config.postMiddle.diameter, this.GAME.config.postMiddle.diameter, this.GAME.config.postMiddle.height, 10),
            position: new CANNON.Vec3(...Object.values(this.GAME.config.postMiddle.position)),
            quaternion: new CANNON.Quaternion().setFromAxisAngle(new CANNON.Vec3(0, 0, 1), Math.PI / 2)
        });

        this.GAME.paddingLeft = new CANNON.Body({
            type: CANNON.Body.STATIC,
            shape: new CANNON.Box(new CANNON.Vec3(this.GAME.config.paddingLeft.width / 2, this.GAME.config.paddingLeft.height / 2, this.GAME.config.paddingLeft.depth / 2)),
            position: new CANNON.Vec3(this.GAME.config.paddingLeft.position.x, this.GAME.config.paddingLeft.position.y, this.GAME.config.paddingLeft.position.z)
        });

        this.GAME.paddingRight = new CANNON.Body({
            type: CANNON.Body.STATIC,
            shape: new CANNON.Box(new CANNON.Vec3(this.GAME.config.paddingRight.width / 2, this.GAME.config.paddingRight.height / 2, this.GAME.config.paddingRight.depth / 2)),
            position: new CANNON.Vec3(this.GAME.config.paddingRight.position.x, this.GAME.config.paddingRight.position.y, this.GAME.config.paddingRight.position.z)
        });

        this.GAME.backWall = new CANNON.Body({
            type: CANNON.Body.STATIC,
            shape: new CANNON.Box(new CANNON.Vec3(this.GAME.config.ground.width - 2, 1, .01)),
            position: new CANNON.Vec3(0, 0.091, -this.GAME.config.ground.height + .724),
            quaternion: new CANNON.Quaternion().setFromAxisAngle(new CANNON.Vec3(1, 0, 0), Math.PI / 1.2)

        });

        // Add a physics body for the pane
        this.GAME.paneBody = new CANNON.Body({
            type: CANNON.Body.STATIC,
            shape: new CANNON.Box(new CANNON.Vec3(this.GAME.config.pane.width / 2, this.GAME.config.pane.height / 2, 0.01)), // Match the pane size
            position: new CANNON.Vec3(this.GAME.config.pane.position.x, this.GAME.config.pane.position.y, this.GAME.config.pane.position.z),
            collisionResponse: false
        });

        this.GAME.paneBody.addEventListener('collide', (event) => {
            if (!this.GAME.isHandled) {
                this.GAME.handleHit(event);
            }
        });

        this.GAME.physicsWorld.addContactMaterial(ballGroundContactMaterial);

        if (this.GAME.config.game.debug) this.GAME.debugger = new CannonDebugger(this.GAME.scene, this.GAME.physicsWorld, { color: 0xff0000 })

        this.GAME.BALL.body.addEventListener('collide', (event) => {
            this.GAME.SOUNDS.bounce(Date.now(), event.contact.getImpactVelocityAlongNormal())
        });

        this.GAME.postMiddle.addEventListener('collide', (event) => {
            this.GAME.SOUNDS.play('metal_pole')
        });

        this.GAME.postLeft.addEventListener('collide', (event) => {
            this.GAME.SOUNDS.play('metal_pole')
        });

        this.GAME.postRight.addEventListener('collide', (event) => {
            this.GAME.SOUNDS.play('metal_pole')
        });

        this.GAME.shotClockPost.addEventListener('collide', (event) => {
            this.GAME.SOUNDS.play('metal_pole')
        });

        this.GAME.shotClockDisplay.addEventListener('collide', (event) => {
            this.GAME.SOUNDS.play('bounce2')
        });

        [this.GAME.BALL.body, this.GAME.groundBody, this.GAME.shotClockPost, this.GAME.shotClockDisplay, this.GAME.paneBody, this.GAME.postLeft, this.GAME.postRight, this.GAME.postMiddle, this.GAME.paddingLeft, this.GAME.paddingRight, this.GAME.backWall]
            .forEach(body => this.GAME.physicsWorld.addBody(body));
    }


    update() {
        this.GAME.physicsWorld.fixedStep(1 / 120);
    }




}